module.exports = __webpack_public_path__ + "img/logo-kemdikbud.e67e95d7.png";